export default __webpack_public_path__ + "static/media/Leah.efd3c923.png";